import { Util } from "@grandvisionhq/forms";
import { uninitState, idleState, failedState, successState, loadingState } from "@grandvisionhq/state";
import { FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_LIST, FETCH_PRODUCT_DATA_SUCCESS, FETCH_PRODUCT_DATA_FAILED, FETCH_PRODUCT_DATA, QUANTITY_SUCCESS, QUANTITY_FAILED, QUANTITY, PAUSE_SUCCESS, PAUSE_FAILED, PAUSE, CCC_ADDRESS_SET_IS_MODAL_OPEN, CCC_ADDRESS_SET_IS_EDIT_MODE, CCC_ADDRESS_SAVE_FAILED, CCC_ADDRESS_SAVE_SUCCESS, CCC_ADDRESS_SAVE, CCC_ADDRESS_RESET, CCC_ADDRESS_UPDATE, FETCH_DETAIL_SUCCESS, FETCH_DETAIL_FAILED, FETCH_DETAIL } from "./actions.js";
const initialState = {
  detailCall: idleState(),
  pauseCall: idleState(),
  quantityCall: idleState(),
  productDataCall: idleState(),
  productData: {},
  cccForm: {
    state: {},
    saveFormCall: idleState(),
    isInEditMode: false,
    isModalOpen: false
  },
  list: uninitState()
};
const getFormState = (address = {}) => {
  const {
    streetName,
    addressLine1,
    addressLine2,
    addressLine3,
    additionalStreetInfo,
    additionalAddressInfo,
    county,
    region,
    ...rest
  } = address;
  const mappedAddress = {
    ...rest,
    streetName: streetName || addressLine1 || "",
    additionalStreetInfo: additionalStreetInfo || addressLine2 || "",
    additionalAddressInfo: additionalAddressInfo || addressLine3 || "",
    region: region || county || ""
  };
  return Util.fieldsToFormState(mappedAddress);
};
function cccReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DETAIL:
      let detail = state.detail;
      if (detail && detail.id !== action.payload.cccSubscriptionId) {
        detail = void 0;
      }
      return {
        ...state,
        detailCall: loadingState(),
        detail
      };
    case FETCH_DETAIL_FAILED:
      return {
        ...state,
        detailCall: failedState(action.error),
        detail: void 0
      };
    case FETCH_DETAIL_SUCCESS:
      return {
        ...state,
        detailCall: idleState(),
        detail: action.payload,
        cccForm: {
          ...state.cccForm,
          state: getFormState(action.payload.deliveryAddress)
        }
      };
    case CCC_ADDRESS_UPDATE:
      return {
        ...state,
        cccForm: {
          ...state.cccForm,
          state: action.payload
        }
      };
    case CCC_ADDRESS_RESET:
      return {
        ...state,
        cccForm: {
          ...initialState.cccForm,
          state: getFormState(state.detail?.deliveryAddress)
        }
      };
    case CCC_ADDRESS_SAVE:
      return {
        ...state,
        cccForm: {
          ...state.cccForm,
          saveFormCall: loadingState()
        }
      };
    case CCC_ADDRESS_SAVE_SUCCESS:
      return {
        ...state,
        cccForm: {
          ...initialState.cccForm,
          state: getFormState(state.detail?.deliveryAddress),
          isModalOpen: true
        }
      };
    case CCC_ADDRESS_SAVE_FAILED:
      return {
        ...state,
        cccForm: {
          ...state.cccForm,
          saveFormCall: failedState(action.error)
        }
      };
    case CCC_ADDRESS_SET_IS_EDIT_MODE:
      return {
        ...state,
        cccForm: {
          ...state.cccForm,
          isInEditMode: action.payload
        }
      };
    case CCC_ADDRESS_SET_IS_MODAL_OPEN:
      return {
        ...state,
        cccForm: {
          ...state.cccForm,
          isModalOpen: action.payload
        }
      };
    case PAUSE:
      return {
        ...state,
        pauseCall: loadingState()
      };
    case PAUSE_FAILED:
      return {
        ...state,
        pauseCall: failedState(action.error)
      };
    case PAUSE_SUCCESS:
      return {
        ...state,
        pauseCall: idleState()
      };
    case QUANTITY:
      return {
        ...state,
        quantityCall: loadingState()
      };
    case QUANTITY_FAILED:
      return {
        ...state,
        quantityCall: "reason" in action.payload ? idleState() : failedState(action.payload)
      };
    case QUANTITY_SUCCESS:
      return {
        ...state,
        quantityCall: idleState()
      };
    case FETCH_PRODUCT_DATA:
      return {
        ...state,
        productDataCall: loadingState(),
        productData: {
          ...state.productData,
          ...action.payload.productIds.reduce((acc, id) => ({ ...acc, [id]: loadingState() }), {})
        }
      };
    case FETCH_PRODUCT_DATA_FAILED:
      const { error, productData } = action.payload;
      return {
        ...state,
        productDataCall: failedState(error),
        productData: {
          ...state.productData,
          ...productData
        }
      };
    case FETCH_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        productDataCall: idleState(),
        productData: {
          ...state.productData,
          ...action.payload.productData
        }
      };
    case FETCH_LIST:
      return {
        ...state,
        list: loadingState()
      };
    case FETCH_LIST_SUCCESS:
      return {
        ...state,
        list: successState(action.payload)
      };
    case FETCH_LIST_FAILED:
      return {
        ...state,
        list: failedState(action.error)
      };
    default:
      return state;
  }
}
export {
  cccReducer,
  initialState
};
//# sourceMappingURL=reducer.js.map
